<template>
    <ns-loader
        ref="ns-loader"
        :to-load="toLoad"
        :fetch-timer="null"
        @dataFetched="onDataFetched"
    >
        <div slot="loader" style="display: flex; justify-content: center; align-items: center;">
            <loading-template></loading-template>
        </div>
        <div
            slot="content"
            class="gcmcn-card-gradient"
            v-loading="loadingWhileTakerGroupFetch"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            style="min-height: 300px;"
        >
            <gcmcn-filters
                :filter-values="[selectedSortType, searchFilter]"
                @reset-filters="resetFilters"
                style="margin-top: 0;"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <template v-if="filterdTakers.length > 0">
                <taker-configuration
                    v-loading="loadingConfiguration"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    v-for="taker in filterdTakers"
                    :key="taker.uid"
                    :taker="taker"
                    :feed="feed"
                    :configurations="feedConfigurations"
                    @on-load-taker-group="loadingWhileTakerGroupFetch = $event"
                    @create-configuration="onCreateconfiguration"
                    @on-configuration-cancelled="$emit('on-configuration-cancelled')"
                    @trigger-refresh="triggerRefresh()"
                ></taker-configuration>
            </template>
            <div v-else-if="takersWithRight.length > 0" class="list-empty">
                No taker(s) match this filters.
            </div>
            <div v-else class="list-empty">
                No taker(s).
            </div>
            <subscribe-modal
                ref="subscribeModal"
                @on-configuration-created="onConfigurationCreated"
            ></subscribe-modal>
        </div>
    </ns-loader>
</template>

<script>
import moment from 'moment';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import {
    SubscribeModal,
    LoadingTemplate,
    Dropdown,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';


import TakerConfiguration from './taker-configuration.vue';
export default {

    components: {
        TakerConfiguration,
        SubscribeModal,
        NsLoader,
        LoadingTemplate,
        Dropdown,
        SearchFilter,
        GcmcnFilters,
    },

    props: {
        broadcastRight: {
            type: Array,
            required: true,
        },
        feedConfigurations: {
            type: Array,
            required: true,
        },
        feed: {
            required: true,
            type: Object,
        },
        event: {
            required: true,
            type: Object,
        },
    },

    data (){
        return {
            loadingConfiguration: false,
            selectedSortType: 'asc',
            searchFilter: '',
            toLoad: [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        status__in: 'AVAILABLE,STARTING,RUNNING,PREPARING',
                    }
                },
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        cancelled: false,
                        feed__isnull: false
                        // status__in: 'PENDING,RUNNING,CONNECTING,CONNECTED'
                    }
                },
            ],
            feeds: [],
            configurations: [],
            loadingWhileTakerGroupFetch: false
        };
    },

    computed: {
        takersWithRight (){
            return this.$store.getters.takers.filter((taker) => {
                return this.broadcastRight.find((br) => br.taker_uid === taker.uid && br.feed_uid === this.feed.uid && br.revoked === false && br.archived === false);
            });
        },
        filterdTakers (){
            let takers = this.takersWithRight.slice();
            if(this.selectedSortType.length > 0){
                takers.sort((a,b) => {
                    return b.name.toLowerCase().localeCompare(a.name.toLowerCase());
                });
                if(this.selectedSortType === 'asc'){
                    takers.reverse();
                }
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                takers = takers.filter((taker) => taker.name.toLowerCase().includes(searchFilter));
            }
            return takers;
        },
        duration() {
            return this.endDateTimeUtc.diff(this.startDateTimeUtc, 'minutes');
        },
        startDateTimeUtc() {
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_start_date);
            }
            return moment.utc(this.feed.start_date);
        },
        endDateTimeUtc() {
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_end_date);
            }
            return moment.utc(this.feed.end_date);
        },
    },
    methods: {
        onCreateconfiguration(taker, takerGroup) {
            this.loadingConfiguration = true;
            this.$refs['ns-loader'].triggerRefresh().then(() => {
                this.loadingConfiguration = false;
                this.$refs.subscribeModal.open(
                    this.feed,
                    this.feeds,
                    'feed',
                    this.configurations,
                    this.event.name,
                    taker,
                    takerGroup,
                    this.duration,
                );
            });
        },
        onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'configurations', res.configurations);
        },
        onConfigurationCreated (){
            this.$refs['ns-loader'].triggerRefresh();
            this.$emit('on-configuration-created');
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        triggerRefresh(){
            this.$emit('trigger-refresh');
        }
    },
};
</script>

<style lang="scss">
.feed-confirguration{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .feed-name{
        font-size: 20px;
    }
    .configuration-buttons{
        width: 80px;

        .el-icon-check{
            font-size: 40px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/configuration.vue